import "shared/ui/topbar/topbar.css";

import { OpenInNew } from "@mui/icons-material";
import {
  Box,
  Drawer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import Logo from "shared/assets/logo.png";
import SupportImage from "shared/assets/support.png";
import { defaultStore } from "shared/common/stores/defaultStore";

interface Props {
  showSupport: boolean;
  setShowSupport: Dispatch<SetStateAction<boolean>>;
}
export default function SupportDrawer(props: Props) {
  const darkTheme = defaultStore((state) => state.darkTheme);

  const { t } = useTranslation();

  const items = [
    {
      text: t("support_drawer.button_1"),
      url: "https://inovitas.atlassian.net/servicedesk/customer/portal/1",
    },
    {
      text: t("support_drawer.button_2"),
      url: "https://inovitas.atlassian.net/servicedesk/customer/portal/1/group/1/create/6",
    },
    {
      text: t("support_drawer.button_3"),
      url: "https://inovitas.atlassian.net/servicedesk/customer/portal/1/group/1/create/8",
    },
    {
      text: t("support_drawer.button_4"),
      url: "https://inovitas.atlassian.net/servicedesk/customer/portal/1/group/1/create/1",
    },
  ];

  return (
    <Drawer
      anchor={"right"}
      open={props.showSupport}
      onClose={() => props.setShowSupport(false)}
      classes={{
        root: "infra3d-drawerRoot",
        paper: darkTheme
          ? "infra3d-paperBackgroundDark"
          : "infra3d-paperBackgroundLight",
      }}
    >
      <Table
        aria-label="sticky table"
        sx={{
          marginBottom: 2,
          backgroundColor: darkTheme ? "darkblue.main" : "white",
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell sx={{ border: "none" }} align="left" colSpan={2}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: 600,
                    color: darkTheme ? "white" : "darkblue.main",
                  }}
                >
                  {t("support_drawer.title")}
                </Typography>
              </Box>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell colSpan={2} sx={{ border: "none", padding: "8px 16px" }}>
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  alignItems: "center",
                  gap: 2,
                  marginBottom: 2,
                }}
              >
                <img width="32px" alt="iNovitas Logo" src={Logo} />
                <Box>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 600,
                      color: darkTheme ? "white" : "darkblue.main",
                    }}
                  >
                    {t("support_drawer.provided")}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 400,
                      color: darkTheme ? "white" : "darkblue.main",
                    }}
                  >
                    {t("support_drawer.version", {
                      version: process.env.npm_package_version,
                    })}
                  </Typography>
                  <a
                    style={{
                      textDecoration: "none",
                    }}
                    href={"mailto:" + t("general.email_support")}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: 400,

                        "@media (hover: hover)": {
                          ":hover": { color: "secondary.main" },
                        },

                        color: darkTheme ? "white" : "primary.main",
                      }}
                    >
                      {t("general.email_support")}
                    </Typography>
                  </a>
                </Box>
              </Box>
              <img width="100%" alt="Support" src={SupportImage} />
            </TableCell>
          </TableRow>
          {items.map((item, index) => (
            <TableRow key={index}>
              <TableCell
                colSpan={2}
                sx={{ border: "none", padding: "4px 16px" }}
              >
                <a
                  style={{
                    textDecoration: "none",
                  }}
                  target={"_blank"}
                  rel="noreferrer"
                  href={item.url}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "left",
                      gap: 1,
                      color: darkTheme ? "white" : "darkblue.main",

                      "@media (hover: hover)": {
                        ":hover": { color: "secondary.main" },
                      },
                    }}
                  >
                    <OpenInNew sx={{ fontSize: "16px" }} />
                    <Typography
                      sx={{
                        fontSize: 16,
                      }}
                    >
                      {" "}
                      {item.text}
                    </Typography>
                  </Box>
                </a>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Drawer>
  );
}
